/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect, useRef, Fragment } from 'react';
import { Input, Form, Select, Button, message } from 'antd';
import './reportConfig.css';

const { Option } = Select;
const { TextArea } = Input;

const ChildApiCustomization = (props) => {
  const [apiProperties, setApiProperties] = useState(props.apiProperties || []);
  const [inputFields, setInputFields] = useState([]);
  const [payloadFields, setPayloadFields] = useState([]);
  const userRef = useRef();

  useEffect(() => {
    if (props.apiProperties !== apiProperties) {
      setApiProperties(props.apiProperties);
    }
  }, [props.apiProperties]);

  const handleFieldChange = (value, colName) => {
    const updatedApiProperties = { ...apiProperties, [colName]: value };
    setApiProperties(updatedApiProperties);
    props.jsonSaveObject(updatedApiProperties, 'childTableApi');
  };

  // const handleChange = (value, keyName, key) => {
  //   const updatedApiProperties = { ...apiProperties };
  //   updatedApiProperties[keyName][key] = value;
  //   setApiProperties(updatedApiProperties);
  //   // props.jsonSaveObject(updatedApiProperties, "api");
  // };

  const apiSave = () => {
      userRef.current && userRef.current.validateFields().then(async () => {
      props.jsonSaveObject(apiProperties, 'childTableApi');
      message.success('Api Validated Successfully');
    });
  };

  const handlePayloadChange = (key, event, objectkey) => {
    const updatedApiProperties = { ...apiProperties };
    if (objectkey === 'key') {
      updatedApiProperties.payload[event.target.value] = updatedApiProperties.payload[key];
      delete updatedApiProperties.payload[key];
    } else if (objectkey === 'value') {
      updatedApiProperties.payload[key] = event.target.value;
    }
    setApiProperties(updatedApiProperties);
    props.jsonSaveObject(updatedApiProperties, 'api');
  };

  const addPayload = () => {
    setInputFields([{ reportKey: '', reportValue: '' }]);
  };

  const handleAddFields = () => {
    setInputFields([...inputFields, { reportKey: '', reportValue: '' }]);
  };

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
  };

  const handleMainPayloadRemoveFields = (index) => {
    const updatedApiProperties = { ...apiProperties };
    delete updatedApiProperties.payload[index];
    setApiProperties(updatedApiProperties);
  };

  const handlePayloadRemoveFields = (index) => {
    const values = [...payloadFields];
    values.splice(index, 1);
    setPayloadFields(values);
  };

  const UpdatePayload = () => {
    const updatedApiProperties = { ...apiProperties };
    payloadFields.forEach(item => {
      updatedApiProperties.payload[item.reportKey] = item.reportValue;
    });
    setPayloadFields([]);
    setApiProperties(updatedApiProperties);
    props.jsonSaveObject(updatedApiProperties, 'api');
  };

  const handlePayloadInputChange = (index, event) => {
    const updatedPayloadFields = [...payloadFields];
    updatedPayloadFields[index][event.target.name] = event.target.value;
    setPayloadFields(updatedPayloadFields);
  };

  const handleAddPayloadFields = () => {
    setPayloadFields([...payloadFields, { reportKey: '', reportValue: '' }]);
  };

  const handleInputChange = (index, event) => {
    const updatedInputFields = [...inputFields];
    updatedInputFields[index][event.target.name] = event.target.value;
    setInputFields(updatedInputFields);
  };

  // const submitPayload = () => {
  //   const updatedApiProperties = { ...apiProperties };
  //   inputFields.forEach(item => {
  //     updatedApiProperties.payload[item.reportKey] = item.reportValue;
  //   });
  //   setApiProperties(updatedApiProperties);
  //   props.jsonSaveObject(updatedApiProperties, 'childTableApi');
  // };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 2 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 }
    }
  };

  return (
    <div style={{ margin: '50px' }}>
      {apiProperties ? (
        <div>
          <Form
            {...formItemLayout}
            ref={userRef}
            name="user_form"
            initialValues={apiProperties || {}}
          >
            <Form.Item
              label="Uri :"
              name="uri"
              rules={[{ required: true, message: 'Please Provide Uri!' }]}
            >
              <Input
                value={apiProperties.uri}
                style={{ width: '100%' }}
                onChange={(e) => handleFieldChange(e.target.value, 'uri')}
              />
            </Form.Item>
            <Form.Item
              label="Method :"
              name="method"
              rules={[{ required: true, message: 'Please Select Method!' }]}
            >
              <Select
                value={apiProperties.method}
                style={{ width: '100%' }}
                onSelect={(value) => handleFieldChange(value, 'method')}
              >
                <Option value="GET">GET</Option>
                <Option value="POST">POST</Option>
              </Select>
            </Form.Item>
            <Form.Item label="Payload :">
              {Object.entries(apiProperties.payload).length > 0 &&
              props.currentTab === 'Edit Report JSON' ? (
                Object.entries(apiProperties.payload).map(([key, value], index) => (
                  <div key={index}>
                    {' '}
                    <input
                      type="text"
                      className="form-control"
                      id="reportKey"
                      name="reportKey"
                      value={key}
                      onChange={(e) => handlePayloadChange(key, e, 'key')}
                    />
                    {/* <label htmlFor="reportName">Last Name</label> */}
                    <input
                      type="text"
                      className="form-control"
                      id="reportValue"
                      name="reportValue"
                      value={value}
                      onChange={(e) => handlePayloadChange(key, e, 'value')}
                    />
                    <Button
                      className="btn-link"
                      type="Button"
                      onClick={() => handleMainPayloadRemoveFields(key)}
                    >
                      -
                    </Button>
                    {Object.keys(apiProperties.payload).length - 1 === index ? (
                      <Button
                        className="btn-link"
                        type="Button"
                        onClick={() => handleAddPayloadFields()}
                      >
                        +
                      </Button>
                    ) : null}
                  </div>
                ))
              ) : (
                <div>
                  <Button onClick={(e) => addPayload(e)}>Add Payload</Button>
                  {inputFields.length > 0 &&
                    inputFields.map((item, index) => (
                      <Fragment key={`${item}~${index}`}>
                        <div>
                          {/* <label htmlFor="reportKey">First Name</label> */}
                          <input
                            type="text"
                            className="form-control"
                            id="reportKey"
                            name="reportKey"
                            value={item.reportKey}
                            onChange={(e) => handleInputChange(index, e)}
                          />

                          {/* <label htmlFor="reportName">Last Name</label> */}
                          <input
                            type="text"
                            className="form-control"
                            id="reportValue"
                            name="reportValue"
                            value={item.reportValue}
                            onChange={(e) => handleInputChange(index, e)}
                          />

                          <Button
                            className="btn-link"
                            type="Button"
                            onClick={() => handleRemoveFields(index)}
                          >
                            -
                          </Button>
                          {inputFields.length - 1 === index ? (
                            <Button
                              className="btn-link"
                              type="Button"
                              onClick={() => handleAddFields()}
                            >
                              +
                            </Button>
                          ) : null}
                        </div>
                        {/* <div><Button onClick={() => submitPayload()}>Submit</Button></div> */}
                      </Fragment>
                    ))}
                </div>
              )}
              {props.currentTab === 'Edit Report JSON' &&
              payloadFields &&
              payloadFields.length > 0
                ? payloadFields.map((item, index) => (
                    <Fragment key={`${item}~${index}`}>
                      <div>
                        {/* <label htmlFor="reportKey">First Name</label> */}
                        <input
                          type="text"
                          className="form-control"
                          id="reportKey"
                          name="reportKey"
                          value={item.reportKey}
                          onChange={(e) => handlePayloadInputChange(index, e)}
                        />

                        {/* <label htmlFor="reportName">Last Name</label> */}
                        <input
                          type="text"
                          className="form-control"
                          id="reportValue"
                          name="reportValue"
                          value={item.reportValue}
                          onChange={(e) => handlePayloadInputChange(index, e)}
                        />

                        <Button
                          className="btn-link"
                          type="Button"
                          onClick={() => handlePayloadRemoveFields(index)}
                        >
                          -
                        </Button>
                        {payloadFields.length - 1 === index ? (
                          <Button
                            className="btn-link"
                            type="Button"
                            onClick={() => handleAddPayloadFields()}
                          >
                            +
                          </Button>
                        ) : null}
                      </div>
                    </Fragment>
                  ))
                : null}
            </Form.Item>

            <Form.Item
              label="Query :"
              name="query"
              rules={[{ required: true, message: 'Please Provide Query!' }]}
            >
              <TextArea
                value={apiProperties.query}
                style={{ width: '550px' }}
                onChange={(e) => handleFieldChange(e.target.value, 'query')}
              />
            </Form.Item>
          </Form>
          <div>
            <Button type="primary" onClick={(e) => apiSave(e)}>
              Validate Json
            </Button>{' '}
            {payloadFields.length > 0 ? (
              <Button type="primary" onClick={(e) => UpdatePayload(e)}>
                UpdatePayload
              </Button>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ChildApiCustomization;